<template>
  <GiscubeLayout v-if="toolsLoaded">
    <slot />
  </GiscubeLayout>
</template>

<script>
import { GiscubeLayout, lib } from '@giscube/geoportal'
const L = lib.L
import SearchBar from 'src/components/Header/SearchBar'
import Vue from 'vue'

export default {
  name: 'BasicLayout',
  components: {
    GiscubeLayout
  },
  data () {
    return {
      toolsLoaded: false
    }
  },
  created () {
    this.fetchMapTools()
  },
  mounted () {
    setTimeout(() => {
      if (this.showFloatingSearchBar) {
        this.addFloatingSearchBar()
      }
    }, 300)
  },
  computed: {
    accessToken () {
      return this.$store?.state.auth.accessToken
    },
    headerVisible () {
      return this.$store?.state.layout.headerVisible
    },
    sidebarVisible () {
      return this.$store?.state.layout.sidebarVisible
    },
    showFloatingSearchBar () {
      console.log(this.$store?.state.layout.showFloatingSearchBar)
      return this.$store?.state.layout.showFloatingSearchBar
    }
  },
  methods: {
    addFloatingSearchBar () {
      const leafletTopCenter = document.createElement('div')
      leafletTopCenter.classList.add('leaflet-top')
      if (this.sidebarVisible) {
        leafletTopCenter.classList.add('leaflet-center-with-sidebar')
      } else {
        leafletTopCenter.classList.add('leaflet-left')
      }
      const leafletControlContainer = document.getElementsByClassName('leaflet-control-container')[0]
      leafletControlContainer.appendChild(leafletTopCenter)
      const leafletControl = document.createElement('div')
      leafletControl.classList.add('giscube-layers-control')
      leafletControl.classList.add('leaflet-control')
      Object.assign(leafletControl.style, {
        'margin-top': '9px',
        'border-radius': '12px'
      })
      leafletTopCenter.appendChild(leafletControl)
      const el = document.createElement('div')
      leafletControl.appendChild(el)
      const SearchBarClass = Vue.extend(SearchBar)
      const instance = new SearchBarClass({
        store: this.$store,
        router: this.$router,
        i18n: this.$i18n
      })
      instance.$mount()
      el.appendChild(instance.$el)
      L.DomEvent.disableClickPropagation(el)
    },
    fetchMapTools () {
      this.$store.dispatch('layout/fetchMapTools', this).then(() => {
        this.toolsLoaded = true
      }).catch(error => {
        this.toolsLoaded = true
        this.$except(error)
      })
    }
  },
  watch: {
    accessToken (newToken, oldToken) {
      if (newToken !== oldToken) {
        this.fetchMapTools()
      }
    },
    showFloatingSearchBar (newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log('showFloatingSearchBar changed:', newValue)
      }
    }
  }
}
</script>

<style>
.leaflet-center-with-sidebar {
  left: calc(var(--map-left) + (100vw - var(--map-left))/2);
  transform: translate(-50%, 0%);
}
.leaflet-center {
  left: 50%;
  transform: translate(-50%, 0%);
}
.leaflet-center.leaflet-middle {
  transform: translate(-50%, -50%);
}
</style>
